<template>
  <div class="loading-indicator"></div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  beforeMount () {
    if (this.consumerName) this.redirect()
  },
  computed: {
    ...mapState(['consumerName']),
    ...mapGetters(['isLmrConsumer']),
  },
  watch: {
    consumerName (val) {
      if (val) this.redirect()
    }
  },
  methods: {
    redirect () {
      this.$router.push('/videos/new')
    }
  },
}
</script>

<style lang="sass" scoped>
.loading-indicator
  margin: auto
</style>
